module.exports = __webpack_public_path__ + "img/c.7319a1dc.png";